import { ComponentProps, ReactNode } from 'react';
import { ErrorIcon } from '@synergy/theme';
import { PoolTypography } from '@synergy/components';
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

// The block heading inside a section — address, e-mail, bank details. The
// section head above it is a small upper-case label on a hairline; this was
// 16-pixel bold with a 20-pixel icon, a size larger than everything around it
// and louder than the head it sits under. It now reads as what it is: a quiet
// second level.
const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
        fontSize: '11.5px',
        lineHeight: '16px',
        color: theme.palette.text.secondary,

        '& svg': {
            marginRight: theme.spacing(0.5),
            fontSize: 14,
        },
    },
    error: {
        color: theme.palette.error.main,
    },
}));

interface SubtitleWithIconProps extends Omit<ComponentProps<typeof PoolTypography>, 'title'> {
    title: ReactNode;
    icon: ReactNode;
    required?: boolean;
    error?: boolean;
}

export const SubtitleWithIcon = (props: SubtitleWithIconProps) => {
    const { icon, title, error, required, ...poolTypographyProps } = props;
    const classes = useStyles();

    return (
        <PoolTypography
            {...poolTypographyProps}
            typography="body1"
            component="span"
            color={error ? 'error' : undefined}
            className={classes.container}
            sx={{ fontWeight: 620 }}
        >
            {error ? <ErrorIcon /> : icon}
            {title}
            {required && ' *'}
        </PoolTypography>
    );
};
